import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { AdminEmployee } from "../../Objects/AdminEmployee/AdminEmployee"
import { GetRequest } from "../../services/ApiClientService"
import { adminEmployeeMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export const useGetAdminEmployee = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetAdminEmployee = async (onSuccess: () => void) => {
    enableLoad()
    try {
      const response = await GetRequest<AdminEmployee[]>(API_ROUTES.ADMIN_EMPLOYEE.GET_ALL, ERequestType.Admin)

      if (response.success) {
        const temp = response.data?.map((ss) => new AdminEmployee(ss)) ?? []

        adminEmployeeMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAdminEmployee,
  }
}
